// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.anonymous-landing-page,
body.anonymous-landing-page {
  overflow: hidden;
  background: #1f2937;
  /* See index.css: 100% overshoots the visible viewport on Chrome for iOS,
     which would push the bottom of the landing's own scroller behind the
     browser toolbar. */
  height: 100%;
  height: 100dvh;
}

.anonymous-landing {
  --scrollbar-track-color: #1c2630;
  --scrollbar-thumb-color: #4b5563;
  height: 100dvh;
  box-sizing: border-box;
  background: #1f2937;
  color: #f7f4ec;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.anonymous-landing__main,
.anonymous-landing__main * {
  scrollbar-width: none;
}

.anonymous-landing__main::-webkit-scrollbar,
.anonymous-landing__main *::-webkit-scrollbar {
  display: none;
}

.anonymous-landing__topbar {
  z-index: 60;
  flex: 0 0 auto;
}

.anonymous-landing__header {
  position: relative;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 1.05rem;
  row-gap: 0.65rem;
  padding: 1.45rem 2.75rem 1.25rem;
  background: rgba(31, 41, 55, 0.92);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex: 0 0 auto;
}

.anonymous-landing__research-banner {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0.48rem 1.5rem 0.52rem;
  background:
    linear-gradient(180deg, rgba(244, 211, 94, 0.98), rgba(231, 183, 55, 0.98));
  color: #4f3b0a;
  border-bottom: 1px solid rgba(120, 82, 14, 0.22);
  box-shadow: inset 0 1px 0 rgba(255, 248, 214, 0.45);
  font-size: 0.9rem;
  line-height: 1.25;
  font-weight: 700;
  letter-spacing: 0;
  text-align: center;
}

.anonymous-landing__research-banner-text {
  grid-column: 2;
}

.anonymous-landing__research-banner-close {
  grid-column: 3;
  justify-self: end;
  width: 1.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #4f3b0a;
  cursor: pointer;
  transition: color 0.15s ease, opacity 0.15s ease;
}

.anonymous-landing__research-banner-close:hover {
  color: rgba(79, 59, 10, 0.72);
}

.anonymous-landing__research-banner-close svg {
  width: 1.05rem;
  height: 1.05rem;
}

.anonymous-landing__nav {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1.9rem;
  min-width: 0;
}

.anonymous-landing__nav-btn {
  border: none;
  background: transparent;
  color: #f9fafb;
  font-size: 1.35rem;
  font-weight: 800;
  letter-spacing: 0;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s ease;
  padding: 0 0.2rem;
}

.anonymous-landing__nav-btn:hover {
  opacity: 1;
}

.anonymous-landing__brand {
  font-size: 2.7rem;
  font-weight: 800;
  letter-spacing: 0;
  color: #f9fafb;
  line-height: 1;
}

.anonymous-landing__header-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.7rem;
  justify-self: end;
}

.anonymous-landing__mobile-menu-btn {
  display: none;
}

.anonymous-landing__sign-in {
  border: none;
  background: transparent;
  color: #f4f0e9;
  font-size: 1.1rem;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s ease;
  white-space: nowrap;
}

.anonymous-landing__sign-in:hover {
  opacity: 0.78;
}

.anonymous-landing__main {
  display: flex;
  flex-direction: column;
  gap: 4rem;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.anonymous-landing__hero {
  padding: 5.2rem 1.5rem 0;
}

.anonymous-landing__hero-inner {
  max-width: 78rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.anonymous-landing__hero-title {
  margin-top: 0;
  max-width: 13ch;
  font-size: 4.5rem;
  line-height: 0.94;
  font-weight: 800;
  letter-spacing: 0;
  color: #f7f4ec;
}

.anonymous-landing__cta {
  margin-top: 2rem;
  min-width: 15rem;
  border: none;
  border-radius: 999px;
  padding: 1rem 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  font-size: 1.3rem;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, filter 0.2s ease;
}

.anonymous-landing__cta:hover {
  transform: translateY(-1px);
  filter: brightness(1.05);
}

.anonymous-landing__cta--primary,
.anonymous-landing__cta--secondary {
  background: #4b858c;
  color: #f7f4ec;
}

.anonymous-landing__partners {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2.5rem;
  padding: 2.5rem 1.5rem 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin-top: 1rem;
}

.anonymous-landing__partner-logo {
  height: 3rem;
  width: auto;
  object-fit: contain;
  opacity: 0.85;
}

.anonymous-landing__partner-logo--uoft {
  filter: brightness(0) invert(1);
}

.anonymous-landing__partner-logo--camh {
  filter: none;
}

.anonymous-landing__intro-video {
  padding: 0 1.5rem;
}

.anonymous-landing__intro-video-trigger {
  position: relative;
  display: block;
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 0;
  border: none;
  border-radius: 1.8rem;
  overflow: hidden;
  cursor: pointer;
  background: #000;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.anonymous-landing__intro-video-trigger:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 56px rgba(255, 255, 255, 0.6);
}

.anonymous-landing__intro-video-thumb {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  opacity: 0.88;
  transition: opacity 0.2s ease;
}

.anonymous-landing__intro-video-trigger:hover .anonymous-landing__intro-video-thumb {
  opacity: 0.72;
}

.anonymous-landing__intro-video-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.anonymous-landing__intro-video-play svg {
  width: 5rem;
  height: 5rem;
}

.anonymous-landing__intro-video-modal {
  width: min(1180px, 100%);
  border-radius: 1.5rem;
  background: #1f2937;
  overflow: hidden;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.5);
}

.anonymous-landing__intro-video-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem 0.9rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.anonymous-landing__intro-video-modal-header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: #f7f4ec;
  letter-spacing: 0;
}

.anonymous-landing__intro-video-modal-frame {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
}

.anonymous-landing__intro-video-modal-frame iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: none;
}

.anonymous-landing__showcase {
  padding: 0 1.5rem;
}

.anonymous-landing__showcase-card {
  max-width: 1180px;
  margin: 2rem auto 0;
  padding: 1.75rem;
  border-radius: 2.2rem;
  background: #e7d3ab;
  border: none;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.18);
}

.anonymous-landing__showcase-visual {
  display: flex;
  border-radius: 1.7rem;
  padding: 1.6rem;
  height: 28rem;
  background: rgba(255, 255, 255, 0.38);
  border: 1px solid rgba(255, 255, 255, 0.55);
  overflow: hidden;
}

.anonymous-landing__demo {
  display: grid;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);
  gap: 1.5rem;
  width: 100%;
  min-height: 100%;
  align-items: stretch;
}

.anonymous-landing__demo--conversation-only {
  flex: 1 1 auto;
  grid-template-columns: minmax(0, 1fr);
  min-height: 31rem;
  align-content: start;
}

.anonymous-landing__demo-conversation {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  min-height: 100%;
  padding-bottom: 1rem;
}

.anonymous-landing__demo-turn {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.5rem;
}

.anonymous-landing__demo-turn--enter {
  animation: anonymous-landing-demo-turn-enter 1.15s cubic-bezier(0.16, 1, 0.3, 1);
}

.anonymous-landing__demo-turn-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
  min-width: 0;
}

.anonymous-landing__demo-avatar {
  flex: 0 0 auto;
  margin-top: 1.6rem;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  background: #ffffff;
}

.anonymous-landing__demo-avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.anonymous-landing__demo-speaker {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.anonymous-landing__demo-turn--speaker-client .anonymous-landing__demo-speaker {
  color: rgba(54, 74, 92, 0.5);
}

.anonymous-landing__demo-turn--speaker-clinician .anonymous-landing__demo-speaker {
  color: #2563eb;
}

.anonymous-landing__demo-bubble {
  padding: 0.75rem 0.9rem;
  border-radius: 1.1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.anonymous-landing__demo-bubble--thinking {
  min-height: 3.95rem;
  display: flex;
  align-items: center;
}

.anonymous-landing__demo-bubble--streaming::after {
  content: '|';
  display: inline-block;
  margin-left: 2px;
  animation: anonymous-landing-blink-cursor 1s step-end infinite;
  color: #6b7280;
  font-weight: 500;
}

.anonymous-landing__demo-turn--speaker-client .anonymous-landing__demo-bubble {
  background: #ede0c4;
  color: #364a5c;
  border: 1px solid rgba(54, 74, 92, 0.18);
}

.anonymous-landing__demo-turn--speaker-clinician .anonymous-landing__demo-bubble {
  background: rgba(37, 99, 235, 0.13);
  color: #364a5c;
  border: 1px solid rgba(37, 99, 235, 0.22);
}

.anonymous-landing__demo-turn--highlight-motivation .anonymous-landing__demo-bubble {
  animation: anonymous-landing-simulation-motivation-flash 0.95s ease-out;
}

.anonymous-landing__demo-turn--highlight-barrier .anonymous-landing__demo-bubble {
  animation: anonymous-landing-simulation-barrier-flash 0.95s ease-out;
}

.anonymous-landing__demo-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  margin-top: 0.45rem;
}

.anonymous-landing__demo-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.anonymous-landing__demo-chip--cr {
  background: rgba(201, 126, 240, 0.16);
  color: #c97ef0;
}

.anonymous-landing__demo-chip--sr {
  background: rgba(47, 158, 158, 0.16);
  color: #2f9e9e;
}

.anonymous-landing__demo-chip--q {
  background: rgba(74, 158, 255, 0.16);
  color: #4a9eff;
}

.anonymous-landing__demo-chip--af {
  background: rgba(76, 175, 136, 0.16);
  color: #4caf88;
}

.anonymous-landing__demo-thinking {
  display: inline-flex;
  flex-wrap: nowrap;
  color: rgba(54, 74, 92, 0.78);
  font-size: 0.84rem;
  font-style: italic;
}

.anonymous-landing__demo-thinking-char {
  display: inline-block;
  opacity: 0.35;
  animation: anonymous-landing-contemplating-wave 1.8s ease-in-out infinite;
}

@keyframes anonymous-landing-contemplating-wave {
  0%, 100% {
    opacity: 0.28;
  }
  50% {
    opacity: 1;
  }
}

@keyframes anonymous-landing-blink-cursor {
  50% {
    opacity: 0;
  }
}

@keyframes anonymous-landing-demo-turn-enter {
  from {
    opacity: 0;
    transform: translateY(1rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes anonymous-landing-demo-feedback-enter {
  from {
    opacity: 0;
    transform: translateY(0.4rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes anonymous-landing-simulation-motivation-flash {
  0%, 100% {
    background: #ede0c4;
    border-color: rgba(54, 74, 92, 0.18);
  }
  35%, 70% {
    background: rgba(16, 185, 129, 0.18);
    border-color: rgba(16, 185, 129, 0.4);
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.12);
  }
}

@keyframes anonymous-landing-simulation-barrier-flash {
  0%, 100% {
    background: #ede0c4;
    border-color: rgba(54, 74, 92, 0.18);
  }
  35%, 70% {
    background: rgba(248, 113, 113, 0.16);
    border-color: rgba(248, 113, 113, 0.42);
    box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.12);
  }
}

.anonymous-landing__demo-panels {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-height: 100%;
  height: 100%;
}

.anonymous-landing__demo-card {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.75rem;
  background: #ede0c4;
  border-radius: 1.1rem;
  border: 1px solid rgba(54, 74, 92, 0.18);
}

.anonymous-landing__demo-card--metrics {
  flex: 1 1 auto;
}

.anonymous-landing__demo-automiti {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.anonymous-landing__demo-automiti-label {
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(54, 74, 92, 0.5);
}

.anonymous-landing__demo-card-title {
  margin: 0;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(54, 74, 92, 0.5);
}

.anonymous-landing__demo-feedback-text {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #364a5c;
}

.anonymous-landing__demo-panel-content--animated {
  animation: anonymous-landing-demo-feedback-enter 0.55s ease-out;
}

.anonymous-landing__demo-feedback-na {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #364a5c;
}

.anonymous-landing__demo-scores-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem 0.75rem;
}

.anonymous-landing__demo-score-item {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.anonymous-landing__demo-score-item span {
  font-size: 0.63rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(54, 74, 92, 0.5);
}

.anonymous-landing__demo-score-item strong {
  font-size: 1.1rem;
  font-weight: 700;
  color: #364a5c;
}

.anonymous-landing__simulation {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(18rem, 0.9fr);
  gap: 1.2rem;
  width: 100%;
  min-height: 100%;
}

.anonymous-landing__simulation-conversation-shell,
.anonymous-landing__simulation-profile-column {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.anonymous-landing__simulation-conversation-shell {
  gap: 0.7rem;
}

.anonymous-landing__simulation-conversation-shell .anonymous-landing__demo-conversation {
  padding-right: 0.35rem;
}

.anonymous-landing__simulation-profile-column {
  justify-content: stretch;
  min-height: 0;
}

.anonymous-landing__simulation-profile-stack {
  display: grid;
  grid-template-rows: minmax(0, 1.15fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.6rem;
  height: 100%;
  min-height: 0;
}

.anonymous-landing__simulation-section {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 0.95rem 1rem;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.58);
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.06);
  min-height: 0;
  overflow: hidden;
}

.anonymous-landing__simulation-section h4 {
  margin: 0;
  font-size: 0.78rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(15, 23, 42, 0.75);
}

.anonymous-landing__simulation-list {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
}

.anonymous-landing__simulation-list::-webkit-scrollbar {
  display: none;
}

.anonymous-landing__simulation-list--numbered .anonymous-landing__simulation-list-item {
  gap: 0.5rem;
}

.anonymous-landing__simulation-list-item {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #0f172a;
}

.anonymous-landing__simulation-list-item--coded {
  display: grid;
  grid-template-columns: 4.8rem minmax(0, 1fr);
  gap: 0.3rem;
}

.anonymous-landing__simulation-list-item--revealed {
  animation: anonymous-landing-demo-feedback-enter 0.55s ease-out;
}

.anonymous-landing__simulation-list-item--highlight-motivation {
  animation: anonymous-landing-simulation-profile-motivation-flash 0.95s ease-out;
}

.anonymous-landing__simulation-list-item--highlight-barrier {
  animation: anonymous-landing-simulation-profile-barrier-flash 0.95s ease-out;
}

.anonymous-landing__simulation-list-item--pending {
  color: rgba(71, 85, 105, 0.82);
  font-style: italic;
}

.anonymous-landing__simulation-index {
  flex: 0 0 auto;
  min-width: 1rem;
  font-weight: 700;
  color: rgba(15, 23, 42, 0.72);
}

.anonymous-landing__simulation-tag {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  justify-self: start;
  padding: 0.12rem 0.38rem;
  border-radius: 999px;
  background: rgba(16, 185, 129, 0.15);
  color: #047857;
  flex-shrink: 0;
}

.anonymous-landing__simulation-tag--placeholder {
  visibility: hidden;
}

.anonymous-landing__simulation-tag--barrier {
  background: rgba(248, 113, 113, 0.18);
  color: #b91c1c;
}

@keyframes anonymous-landing-simulation-profile-motivation-flash {
  0%, 100% {
    background: transparent;
  }
  35%, 70% {
    background: rgba(16, 185, 129, 0.12);
  }
}

@keyframes anonymous-landing-simulation-profile-barrier-flash {
  0%, 100% {
    background: transparent;
  }
  35%, 70% {
    background: rgba(248, 113, 113, 0.12);
  }
}

.anonymous-landing__modes {
  padding: 1rem 1.5rem 0;
}

.anonymous-landing__eyebrow {
  text-align: center;
  font-size: 3.6rem;
  font-weight: 800;
  letter-spacing: 0;
  color: #f7f4ec;
}

.anonymous-landing__section-title {
  max-width: 36rem;
  margin: 0.65rem auto 0;
  text-align: center;
  font-size: 1.45rem;
  line-height: 1.35;
  font-weight: 600;
  letter-spacing: 0;
  color: #f7f4ec;
}

.anonymous-landing__mode-showcase-layout {
  position: relative;
  width: 100%;
  margin: 2rem auto 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.anonymous-landing__mode-showcase-card {
  width: 100%;
  max-width: 1180px;
  height: 33.8rem;
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(18rem, 0.72fr) minmax(0, 1.35fr);
  gap: 1.35rem;
  align-items: stretch;
  padding: 1.4rem;
  border-radius: 2.2rem;
  background: #e7d3ab;
  border: none;
  color: #364a5c;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.18);
}

.anonymous-landing__mode-showcase-nav {
  width: 100%;
  max-width: 1180px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 1rem;
  min-width: 0;
}

.anonymous-landing__mode-showcase-option {
  min-width: 12rem;
  padding: 0.75rem 1.1rem;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(247, 244, 236, 0.7);
  text-align: center;
  cursor: pointer;
  font-size: 1.05rem;
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: 0;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.anonymous-landing__mode-showcase-option:hover {
  background: rgba(255, 255, 255, 0.2);
  color: rgba(247, 244, 236, 0.94);
  transform: translateY(-1px);
}

.anonymous-landing__mode-showcase-option--active {
  background: #e7d3ab;
  transform: translateY(-1px);
  color: #364a5c;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
}

.anonymous-landing__mode-showcase-option:active,
.anonymous-landing__mode-showcase-option--active:hover,
.anonymous-landing__mode-showcase-option--active:focus,
.anonymous-landing__mode-showcase-option--active:active {
  background: #e7d3ab;
  color: #364a5c;
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
}

.anonymous-landing__mode-showcase-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 0.72rem;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  padding: 0.35rem 0.2rem 0.15rem 0;
}

.anonymous-landing__mode-showcase-copy h3 {
  margin: 0;
  font-size: 2.55rem;
  line-height: 0.98;
  font-weight: 700;
  letter-spacing: 0;
  color: #364a5c;
}

.anonymous-landing__mode-showcase-copy p {
  margin: 0;
  max-width: 46ch;
  font-size: 1rem;
  line-height: 1.58;
  color: #364a5c;
}

.anonymous-landing__mode-showcase-visual {
  display: flex;
  min-width: 0;
  min-height: 0;
  padding: 1.3rem;
  border-radius: 1.7rem;
  background: rgba(255, 255, 255, 0.38);
  border: 1px solid rgba(255, 255, 255, 0.55);
  overflow: hidden;
}

.anonymous-landing__mode-showcase-visual > .anonymous-landing__demo,
.anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo,
.anonymous-landing__showcase-visual > .anonymous-landing__simulation {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 100%;
}

.anonymous-landing__mode-showcase-visual > .anonymous-landing__demo--conversation-only,
.anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo {
  min-height: 0;
}

@media (max-width: 900px) {
  .anonymous-landing__simulation {
    grid-template-columns: minmax(0, 1fr);
  }
}

.anonymous-landing__modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(8, 16, 26, 0.72);
  backdrop-filter: blur(8px);
}

.anonymous-landing__modal {
  position: relative;
  width: min(40rem, 100%);
  padding: 2.35rem 2.2rem 1.85rem;
  border-radius: 2rem;
  background: #e7d3ab;
  color: #233548;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.35);
  transform: translateY(-0.85rem);
}

.anonymous-landing__modal--mode-large {
  width: min(76rem, 100%);
  min-height: 34.5rem;
}

.anonymous-landing__modal--mode-large:not(.anonymous-landing__modal--with-demo) {
  display: flex;
  align-items: flex-start;
}

.anonymous-landing__modal--with-demo {
  display: grid;
  grid-template-columns: minmax(0, 0.95fr) minmax(22rem, 1.05fr);
  gap: 1.6rem;
  align-items: stretch;
}

.anonymous-landing__modal-close {
  position: absolute;
  top: 0.95rem;
  right: 1.1rem;
  border: none;
  background: transparent;
  color: #233548;
  font-size: 2rem;
  line-height: 1;
  cursor: pointer;
}

.anonymous-landing__modal-copy {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  padding: 0.45rem 1rem 0.2rem 0.2rem;
}

.anonymous-landing__modal-demo {
  display: flex;
  align-items: stretch;
  min-width: 0;
  padding-top: 0.2rem;
}

.anonymous-landing__modal-demo > .anonymous-landing__demo--conversation-only,
.anonymous-landing__modal-demo > .anonymous-landing__skill-demo {
  flex: 1 1 auto;
  width: 100%;
  min-height: 100%;
}

.anonymous-landing__modal-copy h3 {
  margin: 0 0 1.4rem;
  font-size: 2.55rem;
  line-height: 0.98;
  font-weight: 700;
  letter-spacing: 0;
}

.anonymous-landing__modal-copy p {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.65;
  max-width: 46ch;
}

.anonymous-landing__skill-demo {
  min-height: 31rem;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.anonymous-landing__skill-demo-loading,
.anonymous-landing__skill-demo-exercise {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.anonymous-landing__skill-demo-loading-body {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.anonymous-landing__skill-demo-top {
  flex: 0 0 17.4rem;
  padding-top: 0.6rem;
}

.anonymous-landing__skill-demo-loading-row {
  display: flex;
}

.anonymous-landing__skill-demo-loading-row--right {
  justify-content: flex-end;
}

.anonymous-landing__skill-demo-loading-bubble {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.58rem;
  width: min(100%, 18.5rem);
  padding: 0.95rem 1rem;
  border-radius: 1.15rem;
  background: rgba(237, 224, 196, 0.92);
  border: 1px solid rgba(148, 163, 184, 0.16);
}

.anonymous-landing__skill-demo-loading-bubble::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.65), transparent);
  animation: oarsLoadingSweep 1.8s infinite ease-in-out;
}

.anonymous-landing__skill-demo-loading-bubble--wide {
  width: min(100%, 20rem);
}

.anonymous-landing__skill-demo-loading-bubble--reply {
  width: min(100%, 17rem);
  background: rgba(37, 99, 235, 0.1);
}

.anonymous-landing__skill-demo-loading-line {
  display: block;
  height: 0.75rem;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.42);
}

.anonymous-landing__skill-demo-loading-line--long {
  width: 88%;
}

.anonymous-landing__skill-demo-loading-line--mid {
  width: 64%;
}

.anonymous-landing__skill-demo-loading-line--short {
  width: 42%;
}

.anonymous-landing__skill-demo-message {
  display: flex;
  gap: 0.55rem;
  align-items: flex-start;
}

.anonymous-landing__skill-demo-message--counsellor {
  justify-content: flex-end;
}

.anonymous-landing__skill-demo-avatar {
  flex: 0 0 auto;
  margin-top: 0.55rem;
  width: 2rem;
  height: 2rem;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  background: #ffffff;
}

.anonymous-landing__skill-demo-avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.anonymous-landing__skill-demo-bubble-shell {
  display: inline-flex;
  flex-direction: column;
  max-width: 78%;
}

.anonymous-landing__skill-demo-bubble {
  padding: 0.95rem 1.05rem;
  border-radius: 1.15rem;
  line-height: 1.55;
  font-size: 0.93rem;
  color: #364a5c;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.anonymous-landing__skill-demo-bubble--client {
  background: #ede0c4;
  border: 1px solid rgba(54, 74, 92, 0.18);
}

.anonymous-landing__skill-demo-bubble--counsellor {
  background: rgba(37, 99, 235, 0.13);
  border: 1px solid rgba(37, 99, 235, 0.22);
}

.anonymous-landing__skill-demo-cut {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin: -0.85rem 0 0;
  color: rgba(54, 74, 92, 0.62);
  font-size: 0.73rem;
  font-weight: 700;
}

.anonymous-landing__skill-demo-cut-line {
  flex: 1 1;
  height: 1px;
  background: rgba(54, 74, 92, 0.18);
}

.anonymous-landing__skill-demo-cut-label {
  line-height: 1.2;
  text-align: center;
}

.anonymous-landing__skill-demo-response {
  margin-top: 0.5rem;
}

.anonymous-landing__skill-demo-response-slot {
  flex: 0 0 auto;
  min-height: 6.15rem;
}

.anonymous-landing__skill-demo-response--placeholder {
  visibility: hidden;
}

.anonymous-landing__footer-cta {
  padding: 1rem 1.5rem 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.anonymous-landing__footer-title {
  max-width: 14ch;
  font-size: 4.3rem;
  line-height: 0.95;
  font-weight: 800;
  font-style: italic;
  letter-spacing: 0;
}


.anonymous-landing__sign-in:focus-visible,
.anonymous-landing__cta:focus-visible {
  outline: 3px solid #efe0bb;
  outline-offset: 4px;
}

@media (max-width: 1024px) {
  .anonymous-landing__main {
    gap: 3.2rem;
  }

  .anonymous-landing__hero-title {
    font-size: 3.5rem;
  }

  .anonymous-landing__eyebrow,
  .anonymous-landing__footer-title {
    font-size: 3rem;
  }

  .anonymous-landing__section-title {
    font-size: 1.25rem;
  }

  .anonymous-landing__demo,
  .anonymous-landing__mode-showcase-card {
    grid-template-columns: 1fr;
  }

  .anonymous-landing__mode-showcase-card {
    height: auto;
  }

  .anonymous-landing__showcase-visual {
    height: 19rem;
  }

  .anonymous-landing__mode-showcase-copy {
    padding-right: 0;
  }

  .anonymous-landing__mode-showcase-nav {
    width: 100%;
    max-width: 1180px;
    flex-wrap: wrap;
    gap: 1rem;
  }
}

@media (max-width: 768px) {
  .anonymous-landing {
    --landing-mobile-demo-height: 38rem;
    height: 100dvh;
  }

  .anonymous-landing__header {
    grid-template-columns: 1fr auto;
    align-items: center;
    padding: 0.82rem 0.9rem 0.72rem;
    gap: 0.65rem;
  }

  .anonymous-landing__brand {
    font-size: 1.55rem;
  }

  .anonymous-landing__sign-in {
    font-size: 0.72rem;
    padding: 0.34rem 0;
  }

  .anonymous-landing__research-banner {
    padding: 0.42rem 0.7rem 0.45rem;
    font-size: 0.66rem;
    line-height: 1.2;
  }

  .anonymous-landing__research-banner-close {
    width: 1.45rem;
    height: 1.45rem;
  }

  .anonymous-landing__research-banner-close svg {
    width: 0.9rem;
    height: 0.9rem;
  }

  .anonymous-landing__nav {
    position: absolute;
    top: calc(100% - 0.12rem);
    right: 0.9rem;
    z-index: 75;
    display: none;
    width: min(9.5rem, calc(100vw - 1.8rem));
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    gap: 0.2rem;
    padding: 0.55rem;
    border: 1px solid rgba(247, 244, 236, 0.16);
    border-radius: 0.95rem;
    background: rgba(17, 24, 39, 0.96);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
  }

  .anonymous-landing__nav-btn {
    font-size: 0.72rem;
  }

  .anonymous-landing__nav--open {
    display: flex;
  }

  .anonymous-landing__header-actions {
    gap: 0.45rem;
  }

  .anonymous-landing__mobile-menu-btn {
    width: 2rem;
    height: 2rem;
    padding: 0;
    border: none;
    border-radius: 0;
    background: transparent;
    color: #f7f4ec;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.22rem;
    cursor: pointer;
  }

  .anonymous-landing__mobile-menu-btn span {
    width: 0.94rem;
    height: 0.1rem;
    border-radius: 999px;
    background: currentColor;
    transition: transform 0.18s ease, opacity 0.18s ease;
  }

  .anonymous-landing__mobile-menu-btn--open span:nth-child(1) {
    transform: translateY(0.32rem) rotate(45deg);
  }

  .anonymous-landing__mobile-menu-btn--open span:nth-child(2) {
    opacity: 0;
  }

  .anonymous-landing__mobile-menu-btn--open span:nth-child(3) {
    transform: translateY(-0.32rem) rotate(-45deg);
  }

  .anonymous-landing__sign-in {
    flex: 0 0 auto;
    font-size: 0.72rem;
    line-height: 1;
    padding: 0.38rem 0;
    border: none;
    border-radius: 0;
    background: transparent;
    white-space: nowrap;
  }

  .anonymous-landing__cta--primary {
    margin-top: 1.1rem;
    font-size: 0.98rem;
    padding: 0.72rem 1.35rem;
    width: 9.25rem;
    max-width: 9.25rem;
    min-width: 0;
  }

  .anonymous-landing__brand {
    width: auto;
    font-size: 1.65rem;
  }

  .anonymous-landing__nav-btn {
    flex: 0 0 auto;
    min-width: 0;
    white-space: nowrap;
    font-size: 0.78rem;
    letter-spacing: 0;
    font-weight: 700;
    padding: 0.55rem 0.62rem;
    border-radius: 0.65rem;
    text-align: left;
  }

  .anonymous-landing__nav-btn:hover {
    background: rgba(247, 244, 236, 0.1);
  }

  .anonymous-landing__main {
    gap: 2.7rem;
    padding-bottom: 0;
  }

  .anonymous-landing__hero,
  .anonymous-landing__showcase,
  .anonymous-landing__modes,
  .anonymous-landing__footer-cta {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .anonymous-landing__hero {
    padding-top: 3.4rem;
  }

  .anonymous-landing__hero-title,
  .anonymous-landing__footer-title {
    max-width: none;
  }

  .anonymous-landing__hero-title {
    font-size: 2.65rem;
    line-height: 1;
  }

  .anonymous-landing__eyebrow,
  .anonymous-landing__footer-title {
    font-size: 2.15rem;
    line-height: 1.04;
  }

  .anonymous-landing__section-title {
    font-size: 1.03rem;
    line-height: 1.42;
  }

  .anonymous-landing__showcase-card {
    border-radius: 1.5rem;
    padding: 1rem;
  }

  .anonymous-landing__showcase-visual {
    padding: 0.6rem;
    border-radius: 1.2rem;
    height: 26rem;
    min-height: 26rem;
  }

  .anonymous-landing__showcase-card--simulation .anonymous-landing__showcase-visual {
    height: var(--landing-mobile-demo-height);
    min-height: var(--landing-mobile-demo-height);
  }

  .anonymous-landing__showcase-card--feedback .anonymous-landing__showcase-visual {
    height: var(--landing-mobile-demo-height);
    min-height: var(--landing-mobile-demo-height);
  }

  .anonymous-landing__mode-showcase-card {
    padding: 0.9rem;
    border-radius: 1.5rem;
    gap: 0.85rem;
    height: var(--landing-mobile-demo-height);
    min-height: var(--landing-mobile-demo-height);
    max-height: var(--landing-mobile-demo-height);
    grid-template-rows: 5rem minmax(0, 1fr);
    overflow: hidden;
  }

  .anonymous-landing__mode-showcase-layout {
    margin-top: 1.25rem;
  }

  .anonymous-landing__mode-showcase-nav {
    gap: 0.5rem;
  }

  .anonymous-landing__mode-showcase-option {
    min-width: 0;
    flex: 1 1 30%;
    padding: 0.72rem 0.72rem 0.68rem;
    font-size: 0.9rem;
  }

  .anonymous-landing__mode-showcase-copy {
    gap: 0.5rem;
    padding: 0;
    height: 5rem;
    min-height: 5rem;
    max-height: 5rem;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .anonymous-landing__mode-showcase-copy h3 {
    font-size: 1.6rem;
  }

  .anonymous-landing__mode-showcase-copy p {
    font-size: 0.86rem;
    line-height: 1.48;
  }

  .anonymous-landing__mode-showcase-detail {
    display: none;
  }

  .anonymous-landing__mode-showcase-visual {
    padding: 0.55rem;
    border-radius: 1.2rem;
    display: flex;
    align-items: stretch;
    height: 100%;
    min-height: 0;
    max-height: none;
  }

  .anonymous-landing__showcase-visual > .anonymous-landing__simulation,
  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo,
  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo--conversation-only,
  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo {
    display: flex;
    flex-direction: column;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo .anonymous-landing__demo-conversation,
  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo {
    flex: 1 1 auto;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo .anonymous-landing__demo-conversation,
  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo-top,
  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo-response-slot {
    min-height: 0;
  }

  .anonymous-landing__demo {
    grid-template-columns: 1fr;
  }

  .anonymous-landing__demo-avatar {
    width: 1.7rem;
    height: 1.7rem;
    margin-top: 1.2rem;
  }

  .anonymous-landing__demo-speaker {
    font-size: 0.6rem;
  }

  .anonymous-landing__demo-bubble {
    padding: 0.62rem 0.78rem;
    font-size: 0.78rem;
    line-height: 1.42;
  }

  .anonymous-landing__demo-chip {
    font-size: 0.62rem;
    padding: 0.2rem 0.48rem;
  }

  .anonymous-landing__demo-panels {
    display: none;
  }

  .anonymous-landing__demo--mobile-feedback {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    gap: 0.7rem;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-conversation {
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 0;
    padding-right: 0.2rem;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-panels {
    display: flex;
    flex: 0 0 15rem;
    min-height: 15rem;
    height: 15rem;
    justify-content: flex-end;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-card {
    height: 100%;
    gap: 0.35rem;
    padding: 0.68rem 0.72rem;
    border-radius: 0.85rem;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-card-title {
    font-size: 0.64rem;
    letter-spacing: 0.07em;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-feedback-text {
    font-size: 0.75rem;
    line-height: 1.32;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-feedback-na {
    font-size: 0.92rem;
  }

  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-score-item strong {
    font-size: 0.88rem;
  }

  .anonymous-landing__simulation {
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    height: 100%;
    min-height: 0;
  }

  .anonymous-landing__simulation-conversation-shell {
    flex: 1 1;
    gap: 0.55rem;
    min-height: 0;
    overflow: hidden;
  }

  .anonymous-landing__simulation-conversation-shell .anonymous-landing__demo-conversation {
    height: 100%;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 0;
    padding-right: 0.2rem;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .anonymous-landing__simulation-profile-stack {
    grid-template-rows: repeat(2, minmax(0, 1fr));
    justify-content: stretch;
    gap: 0.45rem;
    height: 100%;
    min-height: 0;
  }

  .anonymous-landing__simulation-profile-column {
    flex: 0 0 13.9rem;
    justify-content: flex-end;
    margin-top: auto;
    min-height: 0;
  }

  .anonymous-landing__simulation-profile-stack > .anonymous-landing__simulation-section:first-child {
    display: none;
  }

  .anonymous-landing__simulation-section {
    gap: 0.35rem;
    padding: 0.68rem 0.72rem;
    border-radius: 0.85rem;
    min-height: 0;
  }

  .anonymous-landing__simulation-section h4 {
    font-size: 0.64rem;
    letter-spacing: 0.07em;
  }

  .anonymous-landing__simulation-list {
    gap: 0.28rem;
    min-height: 0;
  }

  .anonymous-landing__simulation-list--numbered .anonymous-landing__simulation-list-item {
    gap: 0.38rem;
  }

  .anonymous-landing__simulation-list-item {
    gap: 0.34rem;
    font-size: 0.75rem;
    line-height: 1.32;
  }

  .anonymous-landing__simulation-list-item--coded {
    grid-template-columns: 3rem minmax(0, 1fr);
    gap: 0.08rem;
  }

  .anonymous-landing__simulation-index {
    min-width: 0.8rem;
    font-size: 0.72rem;
  }

  .anonymous-landing__simulation-tag {
    font-size: 0.53rem;
    padding: 0.06rem 0.16rem;
  }

  .anonymous-landing__footer-cta {
    padding-top: 0;
    padding-bottom: 0;
  }

  .anonymous-landing__footer-title {
    margin: 0;
  }

  .anonymous-landing__cta--secondary {
    font-size: 1rem;
    padding: 0.7rem 1.3rem;
    width: 9.25rem;
    max-width: 9.25rem;
    min-width: 0;
  }

  .anonymous-landing__modal {
    width: min(34rem, 100%);
    padding: 1.2rem 1rem 0.95rem;
    transform: translateY(-0.55rem);
  }

  .anonymous-landing__modal--mode-large {
    width: min(42rem, 100%);
    min-height: 26rem;
  }

  .anonymous-landing__modal--mode-large:not(.anonymous-landing__modal--with-demo) {
    display: flex;
  }

  .anonymous-landing__modal--with-demo {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .anonymous-landing__demo--conversation-only {
    height: 100%;
    min-height: 100%;
  }

  .anonymous-landing__modal-copy {
    padding: 0;
  }

  .anonymous-landing__skill-demo {
    position: relative;
    height: 100%;
    min-height: 100%;
    padding: 0;
  }

  .anonymous-landing__skill-demo-top {
    flex-basis: 11rem;
  }

  .anonymous-landing__skill-demo-bubble-shell {
    max-width: 82%;
  }

  .anonymous-landing__skill-demo-bubble {
    font-size: 0.78rem;
    padding: 0.68rem 0.78rem;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-top {
    flex-basis: auto;
    height: 15.25rem;
    max-height: 15.25rem;
    overflow: hidden;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-cut {
    position: absolute;
    top: 16.2rem;
    left: 0;
    right: 0;
    margin: 0;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-response-slot {
    position: absolute;
    top: 18.05rem;
    left: 0;
    right: 0;
    min-height: 0;
    margin: 0;
  }

  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-response {
    margin-top: 0;
  }

  .anonymous-landing__partners {
    gap: 1.5rem;
    padding: 2rem 1rem 1.5rem;
  }

  .anonymous-landing__partner-logo {
    height: 2rem;
    max-width: 40vw;
  }
}

@media (max-width: 480px) {
  .anonymous-landing {
    --landing-mobile-demo-height: 35rem;
  }

  .anonymous-landing__nav {
    right: 0.72rem;
  }

  .anonymous-landing__research-banner {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 0.45rem;
    text-align: left;
  }

  .anonymous-landing__research-banner-text {
    grid-column: 1;
  }

  .anonymous-landing__research-banner-close {
    grid-column: 2;
  }

  .anonymous-landing__hero-title {
    font-size: 2.25rem;
  }

  .anonymous-landing__cta {
    width: 100%;
    min-width: 0;
    max-width: 18rem;
  }

  .anonymous-landing__cta--secondary {
    width: 9.25rem;
    max-width: 9.25rem;
  }

  .anonymous-landing__cta--primary {
    width: 9.25rem;
    max-width: 9.25rem;
  }

  .anonymous-landing__intro-video-play svg {
    width: 3.7rem;
    height: 3.7rem;
  }

  .anonymous-landing__showcase-card {
    padding: 0.72rem;
    border-radius: 1.25rem;
  }

  .anonymous-landing__showcase-visual {
    height: 24rem;
    min-height: 24rem;
  }

  .anonymous-landing__showcase-card--simulation .anonymous-landing__showcase-visual,
  .anonymous-landing__showcase-card--feedback .anonymous-landing__showcase-visual {
    height: var(--landing-mobile-demo-height);
    min-height: var(--landing-mobile-demo-height);
  }

  .anonymous-landing__mode-showcase-card {
    height: var(--landing-mobile-demo-height);
    min-height: var(--landing-mobile-demo-height);
    max-height: var(--landing-mobile-demo-height);
    grid-template-rows: 4.5rem minmax(0, 1fr);
  }

  .anonymous-landing__mode-showcase-copy {
    height: 4.5rem;
    min-height: 4.5rem;
    max-height: 4.5rem;
  }

  .anonymous-landing__mode-showcase-copy h3 {
    font-size: 1.45rem;
  }

  .anonymous-landing__mode-showcase-copy p {
    font-size: 0.8rem;
  }

  .anonymous-landing__mode-showcase-nav {
    gap: 0.35rem;
    flex-wrap: nowrap;
  }

  .anonymous-landing__mode-showcase-option {
    flex: 1 1;
    padding: 0.62rem 0.28rem 0.58rem;
    font-size: 0.72rem;
  }

  .anonymous-landing__mode-showcase-visual {
    height: 100%;
    min-height: 0;
    max-height: none;
  }

  .anonymous-landing__footer-title {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/landing/AnonymousLanding.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB;;uBAEqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,+BAA+B;EAC/B;+EAC6E;EAC7E,cAAc;EACd,gDAAgD;EAChD,mDAAmD;EACnD,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,yEAAyE;AAC3E;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oCAAoC;EACtC;EACA;IACE,oCAAoC;IACpC,qCAAqC;IACrC,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,oCAAoC;EACtC;EACA;IACE,qCAAqC;IACrC,uCAAuC;IACvC,+CAA+C;EACjD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;EAC7C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,WAAW;AACb;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,aAAa;EACb,8DAA8D;EAC9D,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,4FAA4F;EAC5F,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,8CAA8C;AAChD;;AAEA;;;;EAIE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,qCAAqC;EACrC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,uFAAuF;EACvF,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,SAAS;EACX;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,aAAa;IACb,wCAAwC;IACxC,sBAAsB;IACtB,oBAAoB;IACpB,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,2CAA2C;IAC3C,sBAAsB;IACtB,kCAAkC;IAClC,2CAA2C;IAC3C,2BAA2B;IAC3B,mCAAmC;EACrC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,wBAAwB;IACxB,oDAAoD;EACtD;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;;;;IAIE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,yCAAyC;IACzC,6CAA6C;EAC/C;;EAEA;IACE,yCAAyC;IACzC,6CAA6C;EAC/C;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,yCAAyC;IACzC,6CAA6C;IAC7C,6CAA6C;IAC7C,uCAAuC;IACvC,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;;;;IAIE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,SAAW;IACX,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,6CAA6C;IAC7C,wBAAwB;IACxB,YAAY;IACZ,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,wBAAwB;IACxB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,+BAA+B;EACjC;;EAEA;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,QAAQ;IACR,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0CAA0C;IAC1C,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,yCAAyC;IACzC,6CAA6C;EAC/C;;EAEA;IACE,yCAAyC;IACzC,6CAA6C;IAC7C,6CAA6C;IAC7C,yCAAyC;EAC3C;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,SAAW;IACX,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["html.anonymous-landing-page,\nbody.anonymous-landing-page {\n  overflow: hidden;\n  background: #1f2937;\n  /* See index.css: 100% overshoots the visible viewport on Chrome for iOS,\n     which would push the bottom of the landing's own scroller behind the\n     browser toolbar. */\n  height: 100%;\n  height: 100dvh;\n}\n\n.anonymous-landing {\n  --scrollbar-track-color: #1c2630;\n  --scrollbar-thumb-color: #4b5563;\n  height: 100dvh;\n  box-sizing: border-box;\n  background: #1f2937;\n  color: #f7f4ec;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.anonymous-landing__main,\n.anonymous-landing__main * {\n  scrollbar-width: none;\n}\n\n.anonymous-landing__main::-webkit-scrollbar,\n.anonymous-landing__main *::-webkit-scrollbar {\n  display: none;\n}\n\n.anonymous-landing__topbar {\n  z-index: 60;\n  flex: 0 0 auto;\n}\n\n.anonymous-landing__header {\n  position: relative;\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 1.05rem;\n  row-gap: 0.65rem;\n  padding: 1.45rem 2.75rem 1.25rem;\n  background: rgba(31, 41, 55, 0.92);\n  backdrop-filter: blur(14px);\n  -webkit-backdrop-filter: blur(14px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex: 0 0 auto;\n}\n\n.anonymous-landing__research-banner {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  padding: 0.48rem 1.5rem 0.52rem;\n  background:\n    linear-gradient(180deg, rgba(244, 211, 94, 0.98), rgba(231, 183, 55, 0.98));\n  color: #4f3b0a;\n  border-bottom: 1px solid rgba(120, 82, 14, 0.22);\n  box-shadow: inset 0 1px 0 rgba(255, 248, 214, 0.45);\n  font-size: 0.9rem;\n  line-height: 1.25;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-align: center;\n}\n\n.anonymous-landing__research-banner-text {\n  grid-column: 2;\n}\n\n.anonymous-landing__research-banner-close {\n  grid-column: 3;\n  justify-self: end;\n  width: 1.75rem;\n  height: 1.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  color: #4f3b0a;\n  cursor: pointer;\n  transition: color 0.15s ease, opacity 0.15s ease;\n}\n\n.anonymous-landing__research-banner-close:hover {\n  color: rgba(79, 59, 10, 0.72);\n}\n\n.anonymous-landing__research-banner-close svg {\n  width: 1.05rem;\n  height: 1.05rem;\n}\n\n.anonymous-landing__nav {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1.9rem;\n  min-width: 0;\n}\n\n.anonymous-landing__nav-btn {\n  border: none;\n  background: transparent;\n  color: #f9fafb;\n  font-size: 1.35rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.2s ease;\n  padding: 0 0.2rem;\n}\n\n.anonymous-landing__nav-btn:hover {\n  opacity: 1;\n}\n\n.anonymous-landing__brand {\n  font-size: 2.7rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  color: #f9fafb;\n  line-height: 1;\n}\n\n.anonymous-landing__header-actions {\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.7rem;\n  justify-self: end;\n}\n\n.anonymous-landing__mobile-menu-btn {\n  display: none;\n}\n\n.anonymous-landing__sign-in {\n  border: none;\n  background: transparent;\n  color: #f4f0e9;\n  font-size: 1.1rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n  white-space: nowrap;\n}\n\n.anonymous-landing__sign-in:hover {\n  opacity: 0.78;\n}\n\n.anonymous-landing__main {\n  display: flex;\n  flex-direction: column;\n  gap: 4rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.anonymous-landing__hero {\n  padding: 5.2rem 1.5rem 0;\n}\n\n.anonymous-landing__hero-inner {\n  max-width: 78rem;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.anonymous-landing__hero-title {\n  margin-top: 0;\n  max-width: 13ch;\n  font-size: 4.5rem;\n  line-height: 0.94;\n  font-weight: 800;\n  letter-spacing: 0;\n  color: #f7f4ec;\n}\n\n.anonymous-landing__cta {\n  margin-top: 2rem;\n  min-width: 15rem;\n  border: none;\n  border-radius: 999px;\n  padding: 1rem 1.75rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  font-size: 1.3rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.2s ease, filter 0.2s ease;\n}\n\n.anonymous-landing__cta:hover {\n  transform: translateY(-1px);\n  filter: brightness(1.05);\n}\n\n.anonymous-landing__cta--primary,\n.anonymous-landing__cta--secondary {\n  background: #4b858c;\n  color: #f7f4ec;\n}\n\n.anonymous-landing__partners {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2.5rem;\n  padding: 2.5rem 1.5rem 2rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  margin-top: 1rem;\n}\n\n.anonymous-landing__partner-logo {\n  height: 3rem;\n  width: auto;\n  object-fit: contain;\n  opacity: 0.85;\n}\n\n.anonymous-landing__partner-logo--uoft {\n  filter: brightness(0) invert(1);\n}\n\n.anonymous-landing__partner-logo--camh {\n  filter: none;\n}\n\n.anonymous-landing__intro-video {\n  padding: 0 1.5rem;\n}\n\n.anonymous-landing__intro-video-trigger {\n  position: relative;\n  display: block;\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n  padding: 0;\n  border: none;\n  border-radius: 1.8rem;\n  overflow: hidden;\n  cursor: pointer;\n  background: #000;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.anonymous-landing__intro-video-trigger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 0 56px rgba(255, 255, 255, 0.6);\n}\n\n.anonymous-landing__intro-video-thumb {\n  display: block;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  object-fit: cover;\n  opacity: 0.88;\n  transition: opacity 0.2s ease;\n}\n\n.anonymous-landing__intro-video-trigger:hover .anonymous-landing__intro-video-thumb {\n  opacity: 0.72;\n}\n\n.anonymous-landing__intro-video-play {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.anonymous-landing__intro-video-play svg {\n  width: 5rem;\n  height: 5rem;\n}\n\n.anonymous-landing__intro-video-modal {\n  width: min(1180px, 100%);\n  border-radius: 1.5rem;\n  background: #1f2937;\n  overflow: hidden;\n  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.5);\n}\n\n.anonymous-landing__intro-video-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem 0.9rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.anonymous-landing__intro-video-modal-header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: #f7f4ec;\n  letter-spacing: 0;\n}\n\n.anonymous-landing__intro-video-modal-frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n}\n\n.anonymous-landing__intro-video-modal-frame iframe {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.anonymous-landing__showcase {\n  padding: 0 1.5rem;\n}\n\n.anonymous-landing__showcase-card {\n  max-width: 1180px;\n  margin: 2rem auto 0;\n  padding: 1.75rem;\n  border-radius: 2.2rem;\n  background: #e7d3ab;\n  border: none;\n  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.18);\n}\n\n.anonymous-landing__showcase-visual {\n  display: flex;\n  border-radius: 1.7rem;\n  padding: 1.6rem;\n  height: 28rem;\n  background: rgba(255, 255, 255, 0.38);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  overflow: hidden;\n}\n\n.anonymous-landing__demo {\n  display: grid;\n  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);\n  gap: 1.5rem;\n  width: 100%;\n  min-height: 100%;\n  align-items: stretch;\n}\n\n.anonymous-landing__demo--conversation-only {\n  flex: 1 1 auto;\n  grid-template-columns: minmax(0, 1fr);\n  min-height: 31rem;\n  align-content: start;\n}\n\n.anonymous-landing__demo-conversation {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  min-height: 100%;\n  padding-bottom: 1rem;\n}\n\n.anonymous-landing__demo-turn {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 0.5rem;\n}\n\n.anonymous-landing__demo-turn--enter {\n  animation: anonymous-landing-demo-turn-enter 1.15s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.anonymous-landing__demo-turn-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.anonymous-landing__demo-avatar {\n  flex: 0 0 auto;\n  margin-top: 1.6rem;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  background: #ffffff;\n}\n\n.anonymous-landing__demo-avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.anonymous-landing__demo-speaker {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.anonymous-landing__demo-turn--speaker-client .anonymous-landing__demo-speaker {\n  color: rgba(54, 74, 92, 0.5);\n}\n\n.anonymous-landing__demo-turn--speaker-clinician .anonymous-landing__demo-speaker {\n  color: #2563eb;\n}\n\n.anonymous-landing__demo-bubble {\n  padding: 0.75rem 0.9rem;\n  border-radius: 1.1rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.anonymous-landing__demo-bubble--thinking {\n  min-height: 3.95rem;\n  display: flex;\n  align-items: center;\n}\n\n.anonymous-landing__demo-bubble--streaming::after {\n  content: '|';\n  display: inline-block;\n  margin-left: 2px;\n  animation: anonymous-landing-blink-cursor 1s step-end infinite;\n  color: #6b7280;\n  font-weight: 500;\n}\n\n.anonymous-landing__demo-turn--speaker-client .anonymous-landing__demo-bubble {\n  background: #ede0c4;\n  color: #364a5c;\n  border: 1px solid rgba(54, 74, 92, 0.18);\n}\n\n.anonymous-landing__demo-turn--speaker-clinician .anonymous-landing__demo-bubble {\n  background: rgba(37, 99, 235, 0.13);\n  color: #364a5c;\n  border: 1px solid rgba(37, 99, 235, 0.22);\n}\n\n.anonymous-landing__demo-turn--highlight-motivation .anonymous-landing__demo-bubble {\n  animation: anonymous-landing-simulation-motivation-flash 0.95s ease-out;\n}\n\n.anonymous-landing__demo-turn--highlight-barrier .anonymous-landing__demo-bubble {\n  animation: anonymous-landing-simulation-barrier-flash 0.95s ease-out;\n}\n\n.anonymous-landing__demo-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  margin-top: 0.45rem;\n}\n\n.anonymous-landing__demo-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.anonymous-landing__demo-chip--cr {\n  background: rgba(201, 126, 240, 0.16);\n  color: #c97ef0;\n}\n\n.anonymous-landing__demo-chip--sr {\n  background: rgba(47, 158, 158, 0.16);\n  color: #2f9e9e;\n}\n\n.anonymous-landing__demo-chip--q {\n  background: rgba(74, 158, 255, 0.16);\n  color: #4a9eff;\n}\n\n.anonymous-landing__demo-chip--af {\n  background: rgba(76, 175, 136, 0.16);\n  color: #4caf88;\n}\n\n.anonymous-landing__demo-thinking {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  color: rgba(54, 74, 92, 0.78);\n  font-size: 0.84rem;\n  font-style: italic;\n}\n\n.anonymous-landing__demo-thinking-char {\n  display: inline-block;\n  opacity: 0.35;\n  animation: anonymous-landing-contemplating-wave 1.8s ease-in-out infinite;\n}\n\n@keyframes anonymous-landing-contemplating-wave {\n  0%, 100% {\n    opacity: 0.28;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes anonymous-landing-blink-cursor {\n  50% {\n    opacity: 0;\n  }\n}\n\n@keyframes anonymous-landing-demo-turn-enter {\n  from {\n    opacity: 0;\n    transform: translateY(1rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes anonymous-landing-demo-feedback-enter {\n  from {\n    opacity: 0;\n    transform: translateY(0.4rem);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes anonymous-landing-simulation-motivation-flash {\n  0%, 100% {\n    background: #ede0c4;\n    border-color: rgba(54, 74, 92, 0.18);\n  }\n  35%, 70% {\n    background: rgba(16, 185, 129, 0.18);\n    border-color: rgba(16, 185, 129, 0.4);\n    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.12);\n  }\n}\n\n@keyframes anonymous-landing-simulation-barrier-flash {\n  0%, 100% {\n    background: #ede0c4;\n    border-color: rgba(54, 74, 92, 0.18);\n  }\n  35%, 70% {\n    background: rgba(248, 113, 113, 0.16);\n    border-color: rgba(248, 113, 113, 0.42);\n    box-shadow: 0 0 0 4px rgba(248, 113, 113, 0.12);\n  }\n}\n\n.anonymous-landing__demo-panels {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  min-height: 100%;\n  height: 100%;\n}\n\n.anonymous-landing__demo-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 0.75rem;\n  background: #ede0c4;\n  border-radius: 1.1rem;\n  border: 1px solid rgba(54, 74, 92, 0.18);\n}\n\n.anonymous-landing__demo-card--metrics {\n  flex: 1 1 auto;\n}\n\n.anonymous-landing__demo-automiti {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.anonymous-landing__demo-automiti-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba(54, 74, 92, 0.5);\n}\n\n.anonymous-landing__demo-card-title {\n  margin: 0;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: rgba(54, 74, 92, 0.5);\n}\n\n.anonymous-landing__demo-feedback-text {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.55;\n  color: #364a5c;\n}\n\n.anonymous-landing__demo-panel-content--animated {\n  animation: anonymous-landing-demo-feedback-enter 0.55s ease-out;\n}\n\n.anonymous-landing__demo-feedback-na {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #364a5c;\n}\n\n.anonymous-landing__demo-scores-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.5rem 0.75rem;\n}\n\n.anonymous-landing__demo-score-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.anonymous-landing__demo-score-item span {\n  font-size: 0.63rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(54, 74, 92, 0.5);\n}\n\n.anonymous-landing__demo-score-item strong {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #364a5c;\n}\n\n.anonymous-landing__simulation {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(18rem, 0.9fr);\n  gap: 1.2rem;\n  width: 100%;\n  min-height: 100%;\n}\n\n.anonymous-landing__simulation-conversation-shell,\n.anonymous-landing__simulation-profile-column {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.anonymous-landing__simulation-conversation-shell {\n  gap: 0.7rem;\n}\n\n.anonymous-landing__simulation-conversation-shell .anonymous-landing__demo-conversation {\n  padding-right: 0.35rem;\n}\n\n.anonymous-landing__simulation-profile-column {\n  justify-content: stretch;\n  min-height: 0;\n}\n\n.anonymous-landing__simulation-profile-stack {\n  display: grid;\n  grid-template-rows: minmax(0, 1.15fr) minmax(0, 1fr) minmax(0, 1fr);\n  gap: 0.6rem;\n  height: 100%;\n  min-height: 0;\n}\n\n.anonymous-landing__simulation-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  padding: 0.95rem 1rem;\n  border: 1px solid rgba(148, 163, 184, 0.4);\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.58);\n  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.06);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.anonymous-landing__simulation-section h4 {\n  margin: 0;\n  font-size: 0.78rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: rgba(15, 23, 42, 0.75);\n}\n\n.anonymous-landing__simulation-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n}\n\n.anonymous-landing__simulation-list::-webkit-scrollbar {\n  display: none;\n}\n\n.anonymous-landing__simulation-list--numbered .anonymous-landing__simulation-list-item {\n  gap: 0.5rem;\n}\n\n.anonymous-landing__simulation-list-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  color: #0f172a;\n}\n\n.anonymous-landing__simulation-list-item--coded {\n  display: grid;\n  grid-template-columns: 4.8rem minmax(0, 1fr);\n  gap: 0.3rem;\n}\n\n.anonymous-landing__simulation-list-item--revealed {\n  animation: anonymous-landing-demo-feedback-enter 0.55s ease-out;\n}\n\n.anonymous-landing__simulation-list-item--highlight-motivation {\n  animation: anonymous-landing-simulation-profile-motivation-flash 0.95s ease-out;\n}\n\n.anonymous-landing__simulation-list-item--highlight-barrier {\n  animation: anonymous-landing-simulation-profile-barrier-flash 0.95s ease-out;\n}\n\n.anonymous-landing__simulation-list-item--pending {\n  color: rgba(71, 85, 105, 0.82);\n  font-style: italic;\n}\n\n.anonymous-landing__simulation-index {\n  flex: 0 0 auto;\n  min-width: 1rem;\n  font-weight: 700;\n  color: rgba(15, 23, 42, 0.72);\n}\n\n.anonymous-landing__simulation-tag {\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  justify-self: start;\n  padding: 0.12rem 0.38rem;\n  border-radius: 999px;\n  background: rgba(16, 185, 129, 0.15);\n  color: #047857;\n  flex-shrink: 0;\n}\n\n.anonymous-landing__simulation-tag--placeholder {\n  visibility: hidden;\n}\n\n.anonymous-landing__simulation-tag--barrier {\n  background: rgba(248, 113, 113, 0.18);\n  color: #b91c1c;\n}\n\n@keyframes anonymous-landing-simulation-profile-motivation-flash {\n  0%, 100% {\n    background: transparent;\n  }\n  35%, 70% {\n    background: rgba(16, 185, 129, 0.12);\n  }\n}\n\n@keyframes anonymous-landing-simulation-profile-barrier-flash {\n  0%, 100% {\n    background: transparent;\n  }\n  35%, 70% {\n    background: rgba(248, 113, 113, 0.12);\n  }\n}\n\n.anonymous-landing__modes {\n  padding: 1rem 1.5rem 0;\n}\n\n.anonymous-landing__eyebrow {\n  text-align: center;\n  font-size: 3.6rem;\n  font-weight: 800;\n  letter-spacing: 0;\n  color: #f7f4ec;\n}\n\n.anonymous-landing__section-title {\n  max-width: 36rem;\n  margin: 0.65rem auto 0;\n  text-align: center;\n  font-size: 1.45rem;\n  line-height: 1.35;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #f7f4ec;\n}\n\n.anonymous-landing__mode-showcase-layout {\n  position: relative;\n  width: 100%;\n  margin: 2rem auto 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  align-items: center;\n}\n\n.anonymous-landing__mode-showcase-card {\n  width: 100%;\n  max-width: 1180px;\n  height: 33.8rem;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: minmax(18rem, 0.72fr) minmax(0, 1.35fr);\n  gap: 1.35rem;\n  align-items: stretch;\n  padding: 1.4rem;\n  border-radius: 2.2rem;\n  background: #e7d3ab;\n  border: none;\n  color: #364a5c;\n  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.18);\n}\n\n.anonymous-landing__mode-showcase-nav {\n  width: 100%;\n  max-width: 1180px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  gap: 1rem;\n  min-width: 0;\n}\n\n.anonymous-landing__mode-showcase-option {\n  min-width: 12rem;\n  padding: 0.75rem 1.1rem;\n  border: none;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  color: rgba(247, 244, 236, 0.7);\n  text-align: center;\n  cursor: pointer;\n  font-size: 1.05rem;\n  line-height: 1.05;\n  font-weight: 800;\n  letter-spacing: 0;\n  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.anonymous-landing__mode-showcase-option:hover {\n  background: rgba(255, 255, 255, 0.2);\n  color: rgba(247, 244, 236, 0.94);\n  transform: translateY(-1px);\n}\n\n.anonymous-landing__mode-showcase-option--active {\n  background: #e7d3ab;\n  transform: translateY(-1px);\n  color: #364a5c;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n}\n\n.anonymous-landing__mode-showcase-option:active,\n.anonymous-landing__mode-showcase-option--active:hover,\n.anonymous-landing__mode-showcase-option--active:focus,\n.anonymous-landing__mode-showcase-option--active:active {\n  background: #e7d3ab;\n  color: #364a5c;\n  transform: translateY(-1px);\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);\n}\n\n.anonymous-landing__mode-showcase-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: 0.72rem;\n  min-width: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0.35rem 0.2rem 0.15rem 0;\n}\n\n.anonymous-landing__mode-showcase-copy h3 {\n  margin: 0;\n  font-size: 2.55rem;\n  line-height: 0.98;\n  font-weight: 700;\n  letter-spacing: 0;\n  color: #364a5c;\n}\n\n.anonymous-landing__mode-showcase-copy p {\n  margin: 0;\n  max-width: 46ch;\n  font-size: 1rem;\n  line-height: 1.58;\n  color: #364a5c;\n}\n\n.anonymous-landing__mode-showcase-visual {\n  display: flex;\n  min-width: 0;\n  min-height: 0;\n  padding: 1.3rem;\n  border-radius: 1.7rem;\n  background: rgba(255, 255, 255, 0.38);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  overflow: hidden;\n}\n\n.anonymous-landing__mode-showcase-visual > .anonymous-landing__demo,\n.anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo,\n.anonymous-landing__showcase-visual > .anonymous-landing__simulation {\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  min-height: 100%;\n}\n\n.anonymous-landing__mode-showcase-visual > .anonymous-landing__demo--conversation-only,\n.anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo {\n  min-height: 0;\n}\n\n@media (max-width: 900px) {\n  .anonymous-landing__simulation {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.anonymous-landing__modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: rgba(8, 16, 26, 0.72);\n  backdrop-filter: blur(8px);\n}\n\n.anonymous-landing__modal {\n  position: relative;\n  width: min(40rem, 100%);\n  padding: 2.35rem 2.2rem 1.85rem;\n  border-radius: 2rem;\n  background: #e7d3ab;\n  color: #233548;\n  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.35);\n  transform: translateY(-0.85rem);\n}\n\n.anonymous-landing__modal--mode-large {\n  width: min(76rem, 100%);\n  min-height: 34.5rem;\n}\n\n.anonymous-landing__modal--mode-large:not(.anonymous-landing__modal--with-demo) {\n  display: flex;\n  align-items: flex-start;\n}\n\n.anonymous-landing__modal--with-demo {\n  display: grid;\n  grid-template-columns: minmax(0, 0.95fr) minmax(22rem, 1.05fr);\n  gap: 1.6rem;\n  align-items: stretch;\n}\n\n.anonymous-landing__modal-close {\n  position: absolute;\n  top: 0.95rem;\n  right: 1.1rem;\n  border: none;\n  background: transparent;\n  color: #233548;\n  font-size: 2rem;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.anonymous-landing__modal-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n  padding: 0.45rem 1rem 0.2rem 0.2rem;\n}\n\n.anonymous-landing__modal-demo {\n  display: flex;\n  align-items: stretch;\n  min-width: 0;\n  padding-top: 0.2rem;\n}\n\n.anonymous-landing__modal-demo > .anonymous-landing__demo--conversation-only,\n.anonymous-landing__modal-demo > .anonymous-landing__skill-demo {\n  flex: 1 1 auto;\n  width: 100%;\n  min-height: 100%;\n}\n\n.anonymous-landing__modal-copy h3 {\n  margin: 0 0 1.4rem;\n  font-size: 2.55rem;\n  line-height: 0.98;\n  font-weight: 700;\n  letter-spacing: 0;\n}\n\n.anonymous-landing__modal-copy p {\n  margin: 0;\n  font-size: 1.1rem;\n  line-height: 1.65;\n  max-width: 46ch;\n}\n\n.anonymous-landing__skill-demo {\n  min-height: 31rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.anonymous-landing__skill-demo-loading,\n.anonymous-landing__skill-demo-exercise {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.anonymous-landing__skill-demo-loading-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.anonymous-landing__skill-demo-top {\n  flex: 0 0 17.4rem;\n  padding-top: 0.6rem;\n}\n\n.anonymous-landing__skill-demo-loading-row {\n  display: flex;\n}\n\n.anonymous-landing__skill-demo-loading-row--right {\n  justify-content: flex-end;\n}\n\n.anonymous-landing__skill-demo-loading-bubble {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 0.58rem;\n  width: min(100%, 18.5rem);\n  padding: 0.95rem 1rem;\n  border-radius: 1.15rem;\n  background: rgba(237, 224, 196, 0.92);\n  border: 1px solid rgba(148, 163, 184, 0.16);\n}\n\n.anonymous-landing__skill-demo-loading-bubble::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.65), transparent);\n  animation: oarsLoadingSweep 1.8s infinite ease-in-out;\n}\n\n.anonymous-landing__skill-demo-loading-bubble--wide {\n  width: min(100%, 20rem);\n}\n\n.anonymous-landing__skill-demo-loading-bubble--reply {\n  width: min(100%, 17rem);\n  background: rgba(37, 99, 235, 0.1);\n}\n\n.anonymous-landing__skill-demo-loading-line {\n  display: block;\n  height: 0.75rem;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.42);\n}\n\n.anonymous-landing__skill-demo-loading-line--long {\n  width: 88%;\n}\n\n.anonymous-landing__skill-demo-loading-line--mid {\n  width: 64%;\n}\n\n.anonymous-landing__skill-demo-loading-line--short {\n  width: 42%;\n}\n\n.anonymous-landing__skill-demo-message {\n  display: flex;\n  gap: 0.55rem;\n  align-items: flex-start;\n}\n\n.anonymous-landing__skill-demo-message--counsellor {\n  justify-content: flex-end;\n}\n\n.anonymous-landing__skill-demo-avatar {\n  flex: 0 0 auto;\n  margin-top: 0.55rem;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  background: #ffffff;\n}\n\n.anonymous-landing__skill-demo-avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.anonymous-landing__skill-demo-bubble-shell {\n  display: inline-flex;\n  flex-direction: column;\n  max-width: 78%;\n}\n\n.anonymous-landing__skill-demo-bubble {\n  padding: 0.95rem 1.05rem;\n  border-radius: 1.15rem;\n  line-height: 1.55;\n  font-size: 0.93rem;\n  color: #364a5c;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n\n.anonymous-landing__skill-demo-bubble--client {\n  background: #ede0c4;\n  border: 1px solid rgba(54, 74, 92, 0.18);\n}\n\n.anonymous-landing__skill-demo-bubble--counsellor {\n  background: rgba(37, 99, 235, 0.13);\n  border: 1px solid rgba(37, 99, 235, 0.22);\n}\n\n.anonymous-landing__skill-demo-cut {\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  margin: -0.85rem 0 0;\n  color: rgba(54, 74, 92, 0.62);\n  font-size: 0.73rem;\n  font-weight: 700;\n}\n\n.anonymous-landing__skill-demo-cut-line {\n  flex: 1;\n  height: 1px;\n  background: rgba(54, 74, 92, 0.18);\n}\n\n.anonymous-landing__skill-demo-cut-label {\n  line-height: 1.2;\n  text-align: center;\n}\n\n.anonymous-landing__skill-demo-response {\n  margin-top: 0.5rem;\n}\n\n.anonymous-landing__skill-demo-response-slot {\n  flex: 0 0 auto;\n  min-height: 6.15rem;\n}\n\n.anonymous-landing__skill-demo-response--placeholder {\n  visibility: hidden;\n}\n\n.anonymous-landing__footer-cta {\n  padding: 1rem 1.5rem 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.anonymous-landing__footer-title {\n  max-width: 14ch;\n  font-size: 4.3rem;\n  line-height: 0.95;\n  font-weight: 800;\n  font-style: italic;\n  letter-spacing: 0;\n}\n\n\n.anonymous-landing__sign-in:focus-visible,\n.anonymous-landing__cta:focus-visible {\n  outline: 3px solid #efe0bb;\n  outline-offset: 4px;\n}\n\n@media (max-width: 1024px) {\n  .anonymous-landing__main {\n    gap: 3.2rem;\n  }\n\n  .anonymous-landing__hero-title {\n    font-size: 3.5rem;\n  }\n\n  .anonymous-landing__eyebrow,\n  .anonymous-landing__footer-title {\n    font-size: 3rem;\n  }\n\n  .anonymous-landing__section-title {\n    font-size: 1.25rem;\n  }\n\n  .anonymous-landing__demo,\n  .anonymous-landing__mode-showcase-card {\n    grid-template-columns: 1fr;\n  }\n\n  .anonymous-landing__mode-showcase-card {\n    height: auto;\n  }\n\n  .anonymous-landing__showcase-visual {\n    height: 19rem;\n  }\n\n  .anonymous-landing__mode-showcase-copy {\n    padding-right: 0;\n  }\n\n  .anonymous-landing__mode-showcase-nav {\n    width: 100%;\n    max-width: 1180px;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .anonymous-landing {\n    --landing-mobile-demo-height: 38rem;\n    height: 100dvh;\n  }\n\n  .anonymous-landing__header {\n    grid-template-columns: 1fr auto;\n    align-items: center;\n    padding: 0.82rem 0.9rem 0.72rem;\n    gap: 0.65rem;\n  }\n\n  .anonymous-landing__brand {\n    font-size: 1.55rem;\n  }\n\n  .anonymous-landing__sign-in {\n    font-size: 0.72rem;\n    padding: 0.34rem 0;\n  }\n\n  .anonymous-landing__research-banner {\n    padding: 0.42rem 0.7rem 0.45rem;\n    font-size: 0.66rem;\n    line-height: 1.2;\n  }\n\n  .anonymous-landing__research-banner-close {\n    width: 1.45rem;\n    height: 1.45rem;\n  }\n\n  .anonymous-landing__research-banner-close svg {\n    width: 0.9rem;\n    height: 0.9rem;\n  }\n\n  .anonymous-landing__nav {\n    position: absolute;\n    top: calc(100% - 0.12rem);\n    right: 0.9rem;\n    z-index: 75;\n    display: none;\n    width: min(9.5rem, calc(100vw - 1.8rem));\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: flex-start;\n    gap: 0.2rem;\n    padding: 0.55rem;\n    border: 1px solid rgba(247, 244, 236, 0.16);\n    border-radius: 0.95rem;\n    background: rgba(17, 24, 39, 0.96);\n    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.24);\n    backdrop-filter: blur(16px);\n    -webkit-backdrop-filter: blur(16px);\n  }\n\n  .anonymous-landing__nav-btn {\n    font-size: 0.72rem;\n  }\n\n  .anonymous-landing__nav--open {\n    display: flex;\n  }\n\n  .anonymous-landing__header-actions {\n    gap: 0.45rem;\n  }\n\n  .anonymous-landing__mobile-menu-btn {\n    width: 2rem;\n    height: 2rem;\n    padding: 0;\n    border: none;\n    border-radius: 0;\n    background: transparent;\n    color: #f7f4ec;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.22rem;\n    cursor: pointer;\n  }\n\n  .anonymous-landing__mobile-menu-btn span {\n    width: 0.94rem;\n    height: 0.1rem;\n    border-radius: 999px;\n    background: currentColor;\n    transition: transform 0.18s ease, opacity 0.18s ease;\n  }\n\n  .anonymous-landing__mobile-menu-btn--open span:nth-child(1) {\n    transform: translateY(0.32rem) rotate(45deg);\n  }\n\n  .anonymous-landing__mobile-menu-btn--open span:nth-child(2) {\n    opacity: 0;\n  }\n\n  .anonymous-landing__mobile-menu-btn--open span:nth-child(3) {\n    transform: translateY(-0.32rem) rotate(-45deg);\n  }\n\n  .anonymous-landing__sign-in {\n    flex: 0 0 auto;\n    font-size: 0.72rem;\n    line-height: 1;\n    padding: 0.38rem 0;\n    border: none;\n    border-radius: 0;\n    background: transparent;\n    white-space: nowrap;\n  }\n\n  .anonymous-landing__cta--primary {\n    margin-top: 1.1rem;\n    font-size: 0.98rem;\n    padding: 0.72rem 1.35rem;\n    width: 9.25rem;\n    max-width: 9.25rem;\n    min-width: 0;\n  }\n\n  .anonymous-landing__brand {\n    width: auto;\n    font-size: 1.65rem;\n  }\n\n  .anonymous-landing__nav-btn {\n    flex: 0 0 auto;\n    min-width: 0;\n    white-space: nowrap;\n    font-size: 0.78rem;\n    letter-spacing: 0;\n    font-weight: 700;\n    padding: 0.55rem 0.62rem;\n    border-radius: 0.65rem;\n    text-align: left;\n  }\n\n  .anonymous-landing__nav-btn:hover {\n    background: rgba(247, 244, 236, 0.1);\n  }\n\n  .anonymous-landing__main {\n    gap: 2.7rem;\n    padding-bottom: 0;\n  }\n\n  .anonymous-landing__hero,\n  .anonymous-landing__showcase,\n  .anonymous-landing__modes,\n  .anonymous-landing__footer-cta {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .anonymous-landing__hero {\n    padding-top: 3.4rem;\n  }\n\n  .anonymous-landing__hero-title,\n  .anonymous-landing__footer-title {\n    max-width: none;\n  }\n\n  .anonymous-landing__hero-title {\n    font-size: 2.65rem;\n    line-height: 1;\n  }\n\n  .anonymous-landing__eyebrow,\n  .anonymous-landing__footer-title {\n    font-size: 2.15rem;\n    line-height: 1.04;\n  }\n\n  .anonymous-landing__section-title {\n    font-size: 1.03rem;\n    line-height: 1.42;\n  }\n\n  .anonymous-landing__showcase-card {\n    border-radius: 1.5rem;\n    padding: 1rem;\n  }\n\n  .anonymous-landing__showcase-visual {\n    padding: 0.6rem;\n    border-radius: 1.2rem;\n    height: 26rem;\n    min-height: 26rem;\n  }\n\n  .anonymous-landing__showcase-card--simulation .anonymous-landing__showcase-visual {\n    height: var(--landing-mobile-demo-height);\n    min-height: var(--landing-mobile-demo-height);\n  }\n\n  .anonymous-landing__showcase-card--feedback .anonymous-landing__showcase-visual {\n    height: var(--landing-mobile-demo-height);\n    min-height: var(--landing-mobile-demo-height);\n  }\n\n  .anonymous-landing__mode-showcase-card {\n    padding: 0.9rem;\n    border-radius: 1.5rem;\n    gap: 0.85rem;\n    height: var(--landing-mobile-demo-height);\n    min-height: var(--landing-mobile-demo-height);\n    max-height: var(--landing-mobile-demo-height);\n    grid-template-rows: 5rem minmax(0, 1fr);\n    overflow: hidden;\n  }\n\n  .anonymous-landing__mode-showcase-layout {\n    margin-top: 1.25rem;\n  }\n\n  .anonymous-landing__mode-showcase-nav {\n    gap: 0.5rem;\n  }\n\n  .anonymous-landing__mode-showcase-option {\n    min-width: 0;\n    flex: 1 1 30%;\n    padding: 0.72rem 0.72rem 0.68rem;\n    font-size: 0.9rem;\n  }\n\n  .anonymous-landing__mode-showcase-copy {\n    gap: 0.5rem;\n    padding: 0;\n    height: 5rem;\n    min-height: 5rem;\n    max-height: 5rem;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .anonymous-landing__mode-showcase-copy h3 {\n    font-size: 1.6rem;\n  }\n\n  .anonymous-landing__mode-showcase-copy p {\n    font-size: 0.86rem;\n    line-height: 1.48;\n  }\n\n  .anonymous-landing__mode-showcase-detail {\n    display: none;\n  }\n\n  .anonymous-landing__mode-showcase-visual {\n    padding: 0.55rem;\n    border-radius: 1.2rem;\n    display: flex;\n    align-items: stretch;\n    height: 100%;\n    min-height: 0;\n    max-height: none;\n  }\n\n  .anonymous-landing__showcase-visual > .anonymous-landing__simulation,\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo,\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo--conversation-only,\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo {\n    flex: 1 1 auto;\n    width: 100%;\n    height: 100%;\n    min-height: 100%;\n    max-height: 100%;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo .anonymous-landing__demo-conversation,\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo {\n    flex: 1 1 auto;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__demo .anonymous-landing__demo-conversation,\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo-top,\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo-response-slot {\n    min-height: 0;\n  }\n\n  .anonymous-landing__demo {\n    grid-template-columns: 1fr;\n  }\n\n  .anonymous-landing__demo-avatar {\n    width: 1.7rem;\n    height: 1.7rem;\n    margin-top: 1.2rem;\n  }\n\n  .anonymous-landing__demo-speaker {\n    font-size: 0.6rem;\n  }\n\n  .anonymous-landing__demo-bubble {\n    padding: 0.62rem 0.78rem;\n    font-size: 0.78rem;\n    line-height: 1.42;\n  }\n\n  .anonymous-landing__demo-chip {\n    font-size: 0.62rem;\n    padding: 0.2rem 0.48rem;\n  }\n\n  .anonymous-landing__demo-panels {\n    display: none;\n  }\n\n  .anonymous-landing__demo--mobile-feedback {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    min-height: 0;\n    gap: 0.7rem;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-conversation {\n    height: 100%;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-bottom: 0;\n    padding-right: 0.2rem;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-panels {\n    display: flex;\n    flex: 0 0 15rem;\n    min-height: 15rem;\n    height: 15rem;\n    justify-content: flex-end;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-card {\n    height: 100%;\n    gap: 0.35rem;\n    padding: 0.68rem 0.72rem;\n    border-radius: 0.85rem;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-card-title {\n    font-size: 0.64rem;\n    letter-spacing: 0.07em;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-feedback-text {\n    font-size: 0.75rem;\n    line-height: 1.32;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-feedback-na {\n    font-size: 0.92rem;\n  }\n\n  .anonymous-landing__demo--mobile-feedback .anonymous-landing__demo-score-item strong {\n    font-size: 0.88rem;\n  }\n\n  .anonymous-landing__simulation {\n    display: flex;\n    flex-direction: column;\n    gap: 0.7rem;\n    height: 100%;\n    min-height: 0;\n  }\n\n  .anonymous-landing__simulation-conversation-shell {\n    flex: 1 1 0;\n    gap: 0.55rem;\n    min-height: 0;\n    overflow: hidden;\n  }\n\n  .anonymous-landing__simulation-conversation-shell .anonymous-landing__demo-conversation {\n    height: 100%;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding-bottom: 0;\n    padding-right: 0.2rem;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .anonymous-landing__simulation-profile-stack {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n    justify-content: stretch;\n    gap: 0.45rem;\n    height: 100%;\n    min-height: 0;\n  }\n\n  .anonymous-landing__simulation-profile-column {\n    flex: 0 0 13.9rem;\n    justify-content: flex-end;\n    margin-top: auto;\n    min-height: 0;\n  }\n\n  .anonymous-landing__simulation-profile-stack > .anonymous-landing__simulation-section:first-child {\n    display: none;\n  }\n\n  .anonymous-landing__simulation-section {\n    gap: 0.35rem;\n    padding: 0.68rem 0.72rem;\n    border-radius: 0.85rem;\n    min-height: 0;\n  }\n\n  .anonymous-landing__simulation-section h4 {\n    font-size: 0.64rem;\n    letter-spacing: 0.07em;\n  }\n\n  .anonymous-landing__simulation-list {\n    gap: 0.28rem;\n    min-height: 0;\n  }\n\n  .anonymous-landing__simulation-list--numbered .anonymous-landing__simulation-list-item {\n    gap: 0.38rem;\n  }\n\n  .anonymous-landing__simulation-list-item {\n    gap: 0.34rem;\n    font-size: 0.75rem;\n    line-height: 1.32;\n  }\n\n  .anonymous-landing__simulation-list-item--coded {\n    grid-template-columns: 3rem minmax(0, 1fr);\n    gap: 0.08rem;\n  }\n\n  .anonymous-landing__simulation-index {\n    min-width: 0.8rem;\n    font-size: 0.72rem;\n  }\n\n  .anonymous-landing__simulation-tag {\n    font-size: 0.53rem;\n    padding: 0.06rem 0.16rem;\n  }\n\n  .anonymous-landing__footer-cta {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .anonymous-landing__footer-title {\n    margin: 0;\n  }\n\n  .anonymous-landing__cta--secondary {\n    font-size: 1rem;\n    padding: 0.7rem 1.3rem;\n    width: 9.25rem;\n    max-width: 9.25rem;\n    min-width: 0;\n  }\n\n  .anonymous-landing__modal {\n    width: min(34rem, 100%);\n    padding: 1.2rem 1rem 0.95rem;\n    transform: translateY(-0.55rem);\n  }\n\n  .anonymous-landing__modal--mode-large {\n    width: min(42rem, 100%);\n    min-height: 26rem;\n  }\n\n  .anonymous-landing__modal--mode-large:not(.anonymous-landing__modal--with-demo) {\n    display: flex;\n  }\n\n  .anonymous-landing__modal--with-demo {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .anonymous-landing__demo--conversation-only {\n    height: 100%;\n    min-height: 100%;\n  }\n\n  .anonymous-landing__modal-copy {\n    padding: 0;\n  }\n\n  .anonymous-landing__skill-demo {\n    position: relative;\n    height: 100%;\n    min-height: 100%;\n    padding: 0;\n  }\n\n  .anonymous-landing__skill-demo-top {\n    flex-basis: 11rem;\n  }\n\n  .anonymous-landing__skill-demo-bubble-shell {\n    max-width: 82%;\n  }\n\n  .anonymous-landing__skill-demo-bubble {\n    font-size: 0.78rem;\n    padding: 0.68rem 0.78rem;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-top {\n    flex-basis: auto;\n    height: 15.25rem;\n    max-height: 15.25rem;\n    overflow: hidden;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-cut {\n    position: absolute;\n    top: 16.2rem;\n    left: 0;\n    right: 0;\n    margin: 0;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-response-slot {\n    position: absolute;\n    top: 18.05rem;\n    left: 0;\n    right: 0;\n    min-height: 0;\n    margin: 0;\n  }\n\n  .anonymous-landing__mode-showcase-visual > .anonymous-landing__skill-demo .anonymous-landing__skill-demo-response {\n    margin-top: 0;\n  }\n\n  .anonymous-landing__partners {\n    gap: 1.5rem;\n    padding: 2rem 1rem 1.5rem;\n  }\n\n  .anonymous-landing__partner-logo {\n    height: 2rem;\n    max-width: 40vw;\n  }\n}\n\n@media (max-width: 480px) {\n  .anonymous-landing {\n    --landing-mobile-demo-height: 35rem;\n  }\n\n  .anonymous-landing__nav {\n    right: 0.72rem;\n  }\n\n  .anonymous-landing__research-banner {\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 0.45rem;\n    text-align: left;\n  }\n\n  .anonymous-landing__research-banner-text {\n    grid-column: 1;\n  }\n\n  .anonymous-landing__research-banner-close {\n    grid-column: 2;\n  }\n\n  .anonymous-landing__hero-title {\n    font-size: 2.25rem;\n  }\n\n  .anonymous-landing__cta {\n    width: 100%;\n    min-width: 0;\n    max-width: 18rem;\n  }\n\n  .anonymous-landing__cta--secondary {\n    width: 9.25rem;\n    max-width: 9.25rem;\n  }\n\n  .anonymous-landing__cta--primary {\n    width: 9.25rem;\n    max-width: 9.25rem;\n  }\n\n  .anonymous-landing__intro-video-play svg {\n    width: 3.7rem;\n    height: 3.7rem;\n  }\n\n  .anonymous-landing__showcase-card {\n    padding: 0.72rem;\n    border-radius: 1.25rem;\n  }\n\n  .anonymous-landing__showcase-visual {\n    height: 24rem;\n    min-height: 24rem;\n  }\n\n  .anonymous-landing__showcase-card--simulation .anonymous-landing__showcase-visual,\n  .anonymous-landing__showcase-card--feedback .anonymous-landing__showcase-visual {\n    height: var(--landing-mobile-demo-height);\n    min-height: var(--landing-mobile-demo-height);\n  }\n\n  .anonymous-landing__mode-showcase-card {\n    height: var(--landing-mobile-demo-height);\n    min-height: var(--landing-mobile-demo-height);\n    max-height: var(--landing-mobile-demo-height);\n    grid-template-rows: 4.5rem minmax(0, 1fr);\n  }\n\n  .anonymous-landing__mode-showcase-copy {\n    height: 4.5rem;\n    min-height: 4.5rem;\n    max-height: 4.5rem;\n  }\n\n  .anonymous-landing__mode-showcase-copy h3 {\n    font-size: 1.45rem;\n  }\n\n  .anonymous-landing__mode-showcase-copy p {\n    font-size: 0.8rem;\n  }\n\n  .anonymous-landing__mode-showcase-nav {\n    gap: 0.35rem;\n    flex-wrap: nowrap;\n  }\n\n  .anonymous-landing__mode-showcase-option {\n    flex: 1 1 0;\n    padding: 0.62rem 0.28rem 0.58rem;\n    font-size: 0.72rem;\n  }\n\n  .anonymous-landing__mode-showcase-visual {\n    height: 100%;\n    min-height: 0;\n    max-height: none;\n  }\n\n  .anonymous-landing__footer-title {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
